// extracted by mini-css-extract-plugin
export default {"clError404Box":"_404_clError404Box__49GJR","Error404Wrap":"_404_Error404Wrap__GPNTB"};